import React, { Fragment, useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import classes from "./userprofile.module.css";
import logo from "../../images/DCL.jpg";
import { CartContext } from "../../../CartContext";
import { AiOutlineArrowLeft } from "react-icons/ai";

function UserProfile() {
  const [username, setUsername] = useState([]);
  const cartCtx = useContext(CartContext);
  const navigate = useNavigate();
  useEffect(() => {
    fetch(
      "https://identitytoolkit.googleapis.com/v1/accounts:lookup?key=AIzaSyCilTl0dDYnSgzy29JLmkLF857SH-WWEx0",
      {
        method: "POST",
        body: JSON.stringify({
          idToken: cartCtx.token,
        }),
      }
    )
      .then((res) => {
        if (!res.ok) {
          return;
        }
        return res.json();
      })
      .then((data) => {
        setUsername(data.users);
      });

    if (!username) {
      return (
        <p>
          Login to view <Link to="/login">Profile</Link>
        </p>
      );
    }
  }, [setUsername]);
  return (
    <div className={classes.container}>
      <span
        onClick={() => navigate("/", { replace: true })}
        className={classes.return}
      >
        <AiOutlineArrowLeft />
      </span>
      {username.map((user, i) => (
        <div key={i} className={classes.image}>
          <img src={logo} />
          <h1>{user.displayName}</h1>
        </div>
      ))}

      <div className={classes.body}>
        <div className={classes.personal}>
          <h2>Personal</h2>
          <div className={classes.list}>
            <Link to="/user">
              <i class="fa-solid fa-user"></i>
              <h1>Profile</h1>
            </Link>

            <Link to="/profile/address">
              <i class="fa-solid fa-location-dot"></i>
              <h1>Delivery Details</h1>
            </Link>

            <Link to="/profile/wallet">
              <i class="fa-solid fa-wallet"></i>
              <h1>Wallet</h1>
            </Link>
          </div>
        </div>
        <div className={classes.personal}>
          <h2>More</h2>
          <div className={classes.list}>
            <Link to="/profile/faq">
              <i class="fa-solid fa-question"></i>
              <h1>FAQs</h1>
            </Link>

            <Link to="/profile/contact">
              <i class="fa-solid fa-message"></i>
              <h1>Contact Us</h1>
            </Link>

            <Link to="">
              <i class="fa-solid fa-bars"></i>
              <h1>Legal</h1>
            </Link>
          </div>
        </div>
        <p>v2.0.0</p>
      </div>
    </div>
  );
}

export default UserProfile;
